// extracted by mini-css-extract-plugin
export var changeIcon = "_44-4";
export var container = "_44-0";
export var divider = "_44-7";
export var externalLinkIcon = "_44-1";
export var green = "_44-5";
export var helpCircleIcon = "_44-3";
export var iconButton = "_44-2";
export var red = "_44-6";